import { render, staticRenderFns } from "./Orcamentos.vue?vue&type=template&id=5d500600&scoped=true&"
import script from "./Orcamentos.vue?vue&type=script&lang=js&"
export * from "./Orcamentos.vue?vue&type=script&lang=js&"
import style0 from "./Orcamentos.vue?vue&type=style&index=0&id=5d500600&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d500600",
  null
  
)

export default component.exports